export function getHttpStatusMessage(status: number): string {
  const statusMessages: { [key: number]: string } = {
    // 2xx Success
    200: "Request successful",
    201: "Resource created",
    204: "Request successful, no content",

    // 3xx Redirection
    301: "Resource moved permanently",
    302: "Resource moved temporarily",
    304: "Resource not modified",

    // 4xx Client Errors
    400: "Bad request",
    401: "Unauthorized access",
    403: "Access forbidden",
    404: "Resource not found",
    405: "Method not allowed",
    408: "Request timeout",
    409: "Resource conflict",
    429: "Too many requests",

    // 5xx Server Errors
    500: "Internal server error",
    501: "Not implemented",
    502: "Bad gateway",
    503: "Service unavailable",
    504: "Gateway timeout",
  };

  return statusMessages[status] || `Unknown status code: ${status}`;
}
